<template>
	<div id='footer'>
		<div class="footera">
			<el-row class="aa">
				<el-col
				 :xs="24"
				 :sm="8"
				 style='height:100%'
				>
					<div
					 class="companyinfo"
					 style="text-align:left"
					>
						<p>昆明市智慧停车建设运营有限公司</p>
						<p>地址：云南省昆明市五华区滇缅大道340号麻园市场综合楼（原麻园药材市场）二楼208室</p>
						<p>电话：15812139818</p>
						<!-- <p>邮箱：1234567@qq.com</p> -->

					</div>
				</el-col>

				<el-col
				 :xs="24"
				 :sm="8"
				 style="text-align:left;padding-left:50px"
				 class="link "
				>
					<p>友情链接：</p>
					<p>
						<a href="">云南昆船数码科技有限公司</a><br></p>
					<p>
						<a
						 href="https://www.ynkg.com/front"
						 target="_blank"
						>云南昆明钢铁控股有限公司</a><br></p>
					<p>
						<a
						 target="_blank"
						 href="http://www.kmjt.net/"
						>昆明市交通投资有限责任公司</a>
					</p>
				</el-col>
				<el-col
				 :xs="24"
				 :sm="8"
				 class=""
				 style="padding-left:50px"
				>
					<el-col :sm='12'><img
						 src="../../assets/img/app.jpg"
						 style='height:150px;width:150px'
						 alt=""
						>
						<p>关注公众号</p>
					</el-col>
					<el-col :sm='12'>
						<img
						 src="../../assets/img/wx.png"
						 alt=""
						 style='height:150px;width:150px'
						>
						<p>扫码下载</p>
					</el-col>

				</el-col>
			</el-row>
			<p style="padding:10px;color: #929293;">    &nbsp;&nbsp;&nbsp; ©Copyright 2020 by 云南昆船数码科技有限公司</p>
	    <div class="footer_beian">
				<span>	<a style="line-height:40px;height:40px;color: rgb(146, 146, 147)" target="_blank" href="https://beian.miit.gov.cn/">	<img src="../../assets/img/cn2.png" width="15px" style="padding-top:2px;padding-right:10px" alt="">滇ICP备17006843号-1</a></span>
          <span style="line-height:40px">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=53010202000930" style="color: rgb(146, 146, 147);display:inline-block;text-decoration:none;height:40px;line-height:40px;margin-left:20px;"> 滇公网安备 53010202000930号 </a>
      </span>
			</div>
		</div>

	</div>
</template>
<script>
export default {
  name: 'yzfooter',
  data() {
    return {};
  },
};
</script>

<style scoped>
.footer_beian{
	display: inline;
}
.footera {
  font-size: 14px;
  min-height: 200px;
  width: 100%;
  background-color: #f2f2f2;
  text-align: center;
  color: #ffffff;
  font-family: '微软雅黑';
  background-color: #474747;
}

.aa {
  padding-top: 80px;
  padding-bottom: 30px;
}
.companyinfo {
  text-align: left;
  margin-left: 50px;
}
.companyinfo p {
  color: #ffffff;
  font-size: 14px;
  line-height: 36px;
}

.link p {
  padding-bottom: 10px !important;
  font-size: 16px;
  text-align: left;
}
a {
  color: #8f8fea;
}
</style>



// WEBPACK FOOTER //
// src/components/common/yzfooter.vue